import styles from './SimStorage.module.css'
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import React, {useEffect, useRef, useState} from "react";
import WorkLine from "../../FormTemplate/WorkLine/WorkLine";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import SelectUnit, {SelectUnitDataInt} from "../../FormTemplate/SelectUnit/SelectUnit";
import TableItem from "../../FormTemplate/TableItem/TableItem";
import ButtonContainer from "../../FormTemplate/ButtonContainer/ButtonContainer";


interface INewParty {
    operId:string
    pointId:string
    mode:number
}

interface IRefOper
{
    operId:string
    name:string
}
interface IRefPoint
{
    pointId:string
    operId:string
}
interface IParty
{
    date:Date
    partyId:string
}
export default function SimStorage()
{
    const refState = useRef<ErrorLineItemRef>(null)




    const dataRefBundle = useRef(null)
    const [ldrRefBundle,rsRefBundle,exRefBundle] = useApiQuery("/sim/storage/ref","post",dataRefBundle)


    const dataNewParty = useRef(new FormData())
    const [ldrNewParty,rsNewParty,exNewParty] = useApiQuery("/sim/storage/party/new","file",dataNewParty)


    const dataParty = useRef(null)
    const [ldrParty,rsParty,exParty] = useApiQuery("/sim/storage/party/list","post",dataParty)
    const [partyList, setPartyList] = useState<IParty[]>([])

    const [crParty, setCrParty] = useState<IParty>()


    const [refOper, setRefOper] = useState<IRefOper[]>([])
    const [refPoint, setRefPoint] = useState<IRefPoint[]>([])

    const [suOper, setSuOper] = useState<SelectUnitDataInt[]>([])
    const [suOperVal, setSuOperVal] = useState<string[]>([])


    const [suPoint, setSuPoint] = useState<SelectUnitDataInt[]>([])
    const [suPointVal, setSuPointVal] = useState<string[]>([])

    const [flSelected, setFlSelected] = useState(false)

    const [suMode, setSuMode] = useState<SelectUnitDataInt[]>([
        {
            name: "Перезаписать",
            val: 0
        },
        {
          name: "Только новые",
          val: 1
        },
    ])
    const [suModeVal, setSuModeVal] = useState<number[]>([])

    const [flSim, setFlSim] = useState<any>()


    useEffect(()=>{
        loadRef()
        loadParty()
    }, [dataRefBundle])



    useEffect(()=>{
        const x:SelectUnitDataInt[] = refOper?.map((item)=>{
            return {
                name: item?.name,
                val: item?.operId
            }
        })
        setSuOper(x)
    },[refOper])

    useEffect(()=>{
        const x = new Array<SelectUnitDataInt>()
        x?.push({name:"Без точки", val: null})
        if(!suOperVal.length)
        {
            setSuPoint([])
            return
        }
        const xp = refPoint?.filter((item)=>{
            const rg = new RegExp("^"+ suOperVal[0]+"$","ui")
            console.log(rg,suOperVal)
            if(item?.operId?.match(rg)) return true
            return false
        })
        const px:SelectUnitDataInt[] = xp?.map((item)=>{
            return{
                name: item?.pointId,
                val:item?.pointId
            }
        })
        setSuPoint(px)
    },[suOperVal])


    const loadParty = ()=>{
        exParty().then((e)=>{
            if(e?.success)
            {
                setPartyList(e?.payload)
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true, 4000)
        })
    }


    const loadRef = ()=>{
        exRefBundle().then((e)=>{
            if(e?.success)
            {
                setRefPoint(e?.payload?.refSimPoint)
                setRefOper(e?.payload?.refSimOper)
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true, 4000)
        })
    }

    const handleSelectFile = (e :React.ChangeEvent<HTMLInputElement>) =>{
        if(e?.target?.files)
        {
            setFlSim(e?.target?.files[0])
            return
        }
        setFlSim(undefined)

    }

    const handleNewParty = () =>{
        if(!refState.current) return
        console.log(suOperVal, suPointVal, suModeVal)
        if(!suOperVal.length){
            refState.current.show("Оператор не выбран", true, 2000)
            return
        }
        if(!suPointVal.length){
            refState.current.show("Точка не выбрана", true, 2000)
            return
        }
        if(!suModeVal.length){
            refState.current.show("Режим не выбран", true, 2000)
            return
        }
        if(!flSim){
            refState.current.show("Файл отгрузки не выбран", true, 2000)
            return
        }

        dataNewParty.current.delete('file')
        dataNewParty.current.delete('data')

        const x:INewParty = {
            mode: Number(suModeVal[0]),
            pointId: suPointVal[0],
            operId: suOperVal[0]

        }
        dataNewParty.current.append('data', JSON.stringify(x))
        dataNewParty.current.append("file",flSim)
        exNewParty().then((e)=>{
            if(e?.success)
            {
                if(refState.current)refState.current.show( `Внесено ${e?.payload?.count} записей`, false, 0)
                loadParty()
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true, 4000)

        })







    }

    return(
        <div className={styles.mainCont}>
            <MainFormTemplate maxWidth={"1000px"} title={"Приход sim карт"}>
                <div className={styles.wrCont}>
                    <WorkLine title={"Процесс"} load={ldrRefBundle || ldrParty || ldrNewParty }></WorkLine>
                </div>

                <div className={"row w-100 mb-2"}>
                    <div className={"d-flex col-md-4"}>
                        <div className={styles.suCont}>
                            <SelectUnit inData={suOper} capt={"Оператор"} getVal={(e)=>setSuOperVal(e)}></SelectUnit>
                        </div>
                    </div>
                    <div className={"d-flex col-md-4"}>
                        <div className={styles.suCont}>
                            <SelectUnit inData={suPoint} capt={"Точка"} getVal={(e)=>setSuPointVal(e)}></SelectUnit>
                        </div>
                    </div>
                    <div className={"d-flex col-md-4"}>
                        <div className={styles.suCont}>
                            <SelectUnit inData={suMode} capt={"Режим"} getVal={(e)=>{setSuModeVal(e)} }></SelectUnit>
                        </div>
                    </div>
                </div>

                <div className={"row w-100 mb-2" }>
                    <div className={"d-flex col-md-12"}>
                        <div className="input-group mb-3">
                            <input type="file" className="form-control" accept={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}
                                   onChange={(e)=>handleSelectFile(e)}
                            >
                            </input>
                        </div>

                    </div>
                </div>

                <ErrorLineItem ref={refState} height={"30px"}/>

                <ButtonContainer resize={true} my={0}>
                    <button type="button" className="btn btn-secondary "
                            onClick={handleNewParty}
                    >Загрузить</button>

                    <button type="button" className="btn btn-secondary "
                        //                            onClick={()=>setDgFaceShot(true)}
                        disabled={!crParty}
                    >Список</button>

                </ButtonContainer>

            </MainFormTemplate>

            <TableItem
                data={partyList}
                onPageCount={30}
                exportExcel={true}
                onReload={()=>loadParty()}
                onRecord={(e:any)=>setCrParty(e)}
                column={[
                    {
                        mode:"sf",
                        title:"Дата",
                        type:2,
                        fieldId: "date"
                    },
                    {
                        mode:"f",
                        title:"Партия",
                        type:0,
                        fieldId: "partyId"
                    },
                    {
                        mode:"sf",
                        title:"Точка",
                        type:0,
                        fieldId: "pointId"
                    },
                    {
                        mode:"sf",
                        title:"Кол-во",
                        type:1,
                        fieldId: "count"
                    },

                ]}

            />
        </div>
    )
}